import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet} from '@angular/router';
import {filter} from 'rxjs';
import {ThemeToggleButtonComponent} from '../../shared/components/theme-toggle/theme-toggle-button.component';

@Component({
  selector: 'app-auth-layout',
  imports: [
    RouterOutlet,
    RouterLink,
  ],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent implements OnInit {


  title = 'Welcome';
  description = 'Verify email to create your new account with Eventz';

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updateContent());
  }

  updateContent(): void {
    const url = this.router.url;

    if (url.includes('login')) {
      this.title = 'Welcome Back';
      this.description = 'Log in to continue.';
    } else if (url.includes('register')) {
      this.title = 'Welcome';
      this.description = 'Verify your email to create a new account with KSNA Marketings.';
    }
  }

  ngOnInit() {

  }
}
